import React from 'react';
import { StyledOption, type StyledOptionProps } from '../styles';
import type { RadioControlGroupOptionProps } from '../RadioControlGroupOption';

type RadioOptionProps = Omit<RadioControlGroupOptionProps, 'children'> &
    StyledOptionProps;

export const RadioOption = ({
    label,
    value,
    error,
    ...props
}: RadioOptionProps) => (
    <StyledOption value={value} error={!!error} {...props}>
        {label}
    </StyledOption>
);
